import React from 'react'
import { Badge } from 'transfix-ui/components/Badge'
import Box from 'transfix-ui/core/Box'
import Skeleton from 'transfix-ui/core/Skeleton'
import Typography from 'transfix-ui/core/Typography'
import { TAG_SIZE, Tag } from 'transfix-ui'
import { CollapsibleSection } from '../../CollapsibleSection'
import { IRulesAssessmentFragment } from './graphql/RulesAssessmentFragment'
import {
  getRuleCountBadgeColorFromResult,
  getTagStyle,
  getTagIcon,
  titleCaseRuleName,
} from './utils'

interface IRulesAssessmentCard {
  title: string
  rules: IRulesAssessmentFragment[]
  loading: boolean
}

export const RulesAssessmentCard = ({ loading, rules, title }: IRulesAssessmentCard) => {
  const count = rules?.length
  const color = getRuleCountBadgeColorFromResult(title, count)

  const Title = () => (
    <Box display='flex' alignItems='center' width='90px' justifyContent='space-between'>
      <Typography variant='subtitle2'>{title}</Typography>
      {loading && (
        <Box mt='-2px'>
          <Skeleton height='33.2px' width='15px' />
        </Box>
      )}
      {!loading && <Badge label={`${count}`} size={TAG_SIZE.small} color={color} />}
    </Box>
  )

  interface IRuleTag {
    result: IRulesAssessmentFragment['result']
    ruleName: IRulesAssessmentFragment['ruleName']
    override?: IRulesAssessmentFragment['override']
  }

  const Icon = getTagIcon(title)
  const RuleTag = ({ override, result, ruleName }: IRuleTag) => {
    const isOverride = !!override?.result
    return (
      <Tag
        label={titleCaseRuleName(ruleName)}
        key={ruleName}
        icon={<Icon />}
        size={TAG_SIZE.small}
        tagStyle={getTagStyle(title, isOverride)}
        style={{ whiteSpace: 'noWrap' }}
        dataTooltip={
          isOverride ? `Result: ${result} Override: ${override?.result || 'None'}` : undefined
        }
        outlineOnly
      />
    )
  }

  return (
    <>
      <CollapsibleSection Title={Title} padding='0'>
        {!!count && (
          <Box display='grid' gap='8px' my='12px'>
            {rules?.map(({ override, result, ruleName }) => (
              <RuleTag key={ruleName} ruleName={ruleName} override={override} result={result} />
            ))}
          </Box>
        )}
      </CollapsibleSection>
    </>
  )
}
